import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import MarketingLayout from "$components/MarketingLayout";
import MailchimpSignup from "$components/MailchimpSignup";
import Hero from "$components/Hero";
import { Flex, Col } from "$components/Flex";
import MarketingSection from "$components/MarketingSection";
import MarketingDivide from "$components/MarketingDivide";
import MarketingCodebox from "$components/MarketingCodebox";
import MarketingBullets from "$components/MarketingBullets";
import MarketingProduct from "$components/MarketingProduct";
import postgresPostgraphileGraphql from "$images/postgres_postgraphile_graphql.png";
import Testimonial from "$components/MarketingTestimonial";
import Sponsors, { Sponsor } from "$components/MarketingSponsor";
import Tiers, { Tier } from "$components/MarketingTier";
export const _frontmatter = {
  "layout": "marketing",
  "path": "/sponsor/",
  "title": "Sponsor PostGraphile and Graphile Engine development"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <MarketingLayout blue mdxType="MarketingLayout">
      <Hero bg="medium" mdxType="Hero">
        <h1>{`Sponsor Graphile’s Open Source Software`}</h1>
      </Hero>
      <MarketingSection bg="medium" mdxType="MarketingSection">
        <h3>{`Who sponsors Graphile?`}</h3>
        <div style={{
          maxWidth: '48rem',
          margin: '0 auto'
        }}>
          <p>{`We’re extremely grateful to the following individuals and businesses that help
to fund ongoing development on the Graphile suite through sponsorship. `}<strong parentName="p">{`THANK
YOU!`}</strong></p>
        </div>
        {
          /* SPONSORS_BEGIN */
        }
        <Sponsors level="featured" mdxType="Sponsors">
  <Sponsor name="Steelhead" avatar="/images/sponsors/steelhead.svg" href="https://gosteelhead.com/" business mdxType="Sponsor" />
        </Sponsors>
        <Sponsors level="leaders" mdxType="Sponsors">
  <Sponsor name="Robert Claypool" mdxType="Sponsor" />
  <Sponsor name="nigelrmtaylor" mdxType="Sponsor" />
  <Sponsor name="Principia Mentis" avatar="/images/sponsors/principiamentis.png" business mdxType="Sponsor" />
  <Sponsor name="Axinom" avatar="/images/sponsors/axinom.png" business mdxType="Sponsor" />
  <Sponsor name="Taiste" avatar="/images/sponsors/taiste-sq.svg" business mdxType="Sponsor" />
  <Sponsor name="Trigger.dev" avatar="/images/sponsors/triggerdev.png" business mdxType="Sponsor" />
  <Sponsor name="Apollo" avatar="/images/sponsors/apollo.png" business mdxType="Sponsor" />
  <Sponsor name="Cintra" avatar="/images/sponsors/cintra.svg" business mdxType="Sponsor" />
  <Sponsor name="BairesDev" avatar="/images/sponsors/BairesDev.png" href="https://www.bairesdev.com/sponsoring-open-source-projects/" business mdxType="Sponsor" />
  <Sponsor name="Two Bit Solutions" avatar="/images/sponsors/two-bits.svg" business mdxType="Sponsor" />
  <Sponsor name="Dimply" avatar="/images/sponsors/dimply.svg" business mdxType="Sponsor" />
  <Sponsor name="Ndustrial" avatar="/images/sponsors/ndustrial.png" business mdxType="Sponsor" />
  <Sponsor name="Beacon" avatar="/images/sponsors/beaconbio.jpg" business mdxType="Sponsor" />
  <Sponsor name="Ravio" avatar="/images/sponsors/Ravio.svg" business mdxType="Sponsor" />
  <Sponsor name="Outbank" avatar="/images/sponsors/outbank.png" href="https://outbankapp.com/" business mdxType="Sponsor" />
  <Sponsor name="prodready" mdxType="Sponsor" />
  <Sponsor name="Carvajal Consultants, Inc. " mdxType="Sponsor" />
  <Sponsor name="Constructive" avatar="/images/sponsors/constructive.svg" href="https://constructive.io/" business mdxType="Sponsor" />
  <Sponsor name="Seaber" avatar="/images/sponsors/Seaber.png" business mdxType="Sponsor" />
        </Sponsors>
        <Sponsors level="supporters" mdxType="Sponsors">
  <Sponsor name="HR-ON" business mdxType="Sponsor" />
  <Sponsor name="stlbucket" contributor mdxType="Sponsor" />
  <Sponsor name="Simon Elliott" mdxType="Sponsor" />
  <Sponsor name="Keith Layne" mdxType="Sponsor" />
  <Sponsor name="Alvin Ali Khaled" mdxType="Sponsor" />
  <Sponsor name="nullachtvierzehn" mdxType="Sponsor" />
  <Sponsor name="Zymego" business mdxType="Sponsor" />
  <Sponsor name="garpulon" mdxType="Sponsor" />
  <Sponsor name="Ether" business mdxType="Sponsor" />
  <Sponsor name="Vizcom" mdxType="Sponsor" />
  <Sponsor name="The Outbound Collective" business mdxType="Sponsor" />
  <Sponsor name="Kiron Open Higher Education" business mdxType="Sponsor" />
  <Sponsor name="Andrew Joseph" mdxType="Sponsor" />
  <Sponsor name="Peter C. Romano" mdxType="Sponsor" />
  <Sponsor name="mateo" mdxType="Sponsor" />
  <Sponsor name="kontakto-fi" mdxType="Sponsor" />
  <Sponsor name="Tailos, Inc." mdxType="Sponsor" />
  <Sponsor name="Jody Hoon-Starr" mdxType="Sponsor" />
  <Sponsor name="WorkOS" business mdxType="Sponsor" />
  <Sponsor name="Justin Carrus" mdxType="Sponsor" />
  <Sponsor name="Malachi Bergman" mdxType="Sponsor" />
  <Sponsor name="ProbablyBrianBurgess" mdxType="Sponsor" />
  <Sponsor name="Keweiqu" mdxType="Sponsor" />
  <Sponsor name="jjcroftiv" mdxType="Sponsor" />
        </Sponsors>
        <Sponsors level="backers" mdxType="Sponsors">
  <Sponsor name="plus 37 more backers..." plain mdxType="Sponsor" />
        </Sponsors>
        {
          /* SPONSORS_END */
        }
      </MarketingSection>
      <MarketingDivide from="medium" to="white" via="light" mdxType="MarketingDivide" />
      <MarketingSection bg="white" left maxWidth mdxType="MarketingSection">
        <h3>
  Graphile has a number of crowd-funded open-source projects, licensed under
  the permissive MIT license, including PostGraphile, Graphile Worker,
  Graphile Migrate and Graphile Starter. Sponsorship increases the rate of
  fixes, documentation improvements, and feature development on these and
  other projects.
        </h3>
        <div className="flex">
  <a className="button--solid" href="https://github.com/users/benjie/sponsorship">
    Sponsor Graphile’s Open Source Software{" "}
    <span className="fas fa-fw fa-external-link-square-alt" />
  </a>
        </div>
      </MarketingSection>
      <MarketingDivide from="white" to="medium" via="light" mdxType="MarketingDivide" />
      <MarketingSection bg="medium" mdxType="MarketingSection">
        <Flex mdxType="Flex">
          <Col span="6" mdxType="Col">
            <img src="/images/grafast-hero.png" alt="A suited man reveals the Grafast heart logo on his chest, in the style of Superman" className="br2" style={{
              borderRadius: "10px",
              border: "2px solid #1b1b3d"
            }} />
          </Col>
          <Col span="6" mdxType="Col">
            <MarketingProduct big name={<span>Support Gra<em>fast</em> and PostGraphile V5</span>} headline="The next-generation planning and execution engine for GraphQL" mdxType="MarketingProduct">
              <p>{`Gra`}<em>{`fast`}</em>{` and PostGraphile Version 5 are now in open beta thanks in large
part to the support given through sponsorship.`}</p>
              <p>{`Sponsorship is the most effective way to support our open source projects
`}{`—`}{` it enables us to invest time directly into their maintenance and
advancement without adding additional time burdens.`}</p>
              <div className="df flex-row justify-center" style={{
                height: "3rem"
              }}>
  <div className="ph2 df flex-column justify-center">
    <a className="button--solid" href="https://github.com/users/benjie/sponsorship">
      <span className="fas fa-heart" /> Sponsor on GitHub{" "}
      <span className="fas fa-external-link-square-alt" />
    </a>{" "}
  </div>
  <div className="ph2 df flex-column justify-center">
    <a className="button--solid" href="https://grafast.org" target="_new">
      grafast.org <span className="fas fa-external-link-square-alt" />
    </a>{" "}
  </div>
              </div>
            </MarketingProduct>
          </Col>
        </Flex>
      </MarketingSection>
      <MarketingDivide from="medium" to="dark" via="light" mdxType="MarketingDivide" />
      <MarketingSection bg="dark" left maxWidth mdxType="MarketingSection">
        <h3>{`Why “crowd-funded open-source project”?`}</h3>
        <p>{`Many of our projects are open-source to give users great freedom in how they use
the software, and to enable the community to have influence over how the
projects progress to make it appropriate for a wide range of use-cases. To
ensure users can rely on these projects for years to come, they need to be well
directed and financially sustainable.`}</p>
        <p><strong parentName="p">{`The best way to ensure that Graphile software is something you can depend on
for years to come is through monthly sponsorship.`}</strong>{` Crowd-sourced funding
enables us to spend the most time directly working on improving the software,
which you and other users then benefit from.`}</p>
      </MarketingSection>
      <MarketingDivide from="dark" to="medium" via="light" down mdxType="MarketingDivide" />
      <MarketingSection bg="medium" left maxWidth mdxType="MarketingSection">
      </MarketingSection>
      <MarketingSection bg="medium" left mdxType="MarketingSection">
        <Tiers mdxType="Tiers">
  <Tier name="Supporter" price="$25" tagline="Thank you!" href="https://github.com/sponsors/benjie/sponsorships?tier_id=369" description={<ul>
        <li>Your name on the Graphile Sponsors page</li>
        <li>Graphile stickers</li>
        <li>Your name among those randomly featured in the PostGraphile CLI</li>
        <li>Post job opportunities to our Discord community</li>
        <li>Access to the #supporter-lounge on Discord</li>
        <li>
          The warm feeling from knowing you’re supporting Open Source Software
        </li>
      </ul>} mdxType="Tier" />
  <Tier name="Production Sponsor" highlight price="$100" tagline="Support sustainability" href="https://github.com/sponsors/benjie/sponsorships?tier_id=368" description={<ul>
        <li>The Supporter tier benefits and...</li>
        <li>
          Access to <strong>private security announcements</strong>
        </li>
        <li>
          Free access to{" "}
          <a href="https://postgraphile.org/pricing">
            <strong>PostGraphile V4 Pro</strong>
          </a>{" "}
          and{" "}
          <a href="https://worker.graphile.org/pricing">
            <strong>Worker Pro</strong>
          </a>
        </li>
        <li>
          Access to{" "}
          <a href="https://github.com/graphile-pro">
            <strong>graphile-pro</strong>
          </a>
        </li>
        <li>
          Your name and <strong>avatar/logo</strong> featured on our websites
        </li>
        <li>
          Your name <strong>more frequently featured</strong> in the
          PostGraphile CLI
        </li>
        <li>
          The warm feeling that comes from knowing you’re making a difference to
          the sustainability of the Graphile suite of tooling
        </li>
      </ul>} mdxType="Tier" />
  <Tier name="Featured Sponsor" price="$500" tagline="Get featured in the project" href="https://github.com/sponsors/benjie/sponsorships?tier_id=367" description={<ul>
        <li>The Production tier benefits and...</li>
        <li>
          Your name and avatar/logo{" "}
          <strong>
            featured in the READMEs of Graphile’s main OSS projects
          </strong>{" "}
          (shown on GitHub and npm)
        </li>
        <li>
          Your name and <strong>avatar/logo prominently featured </strong>on our
          websites
        </li>
        <li>
          Your name <strong>even more frequently featured</strong> in the
          PostGraphile CLI
        </li>
        <li>
          Access to <strong>#vip-lounge</strong> on Discord
        </li>
        <li>
          Free access to{" "}
          <strong>
            <a href="https://pgrita.com">pgRITA</a>
          </strong>
        </li>
        <li>
          The warm feeling that comes from knowing{" "}
          <strong>
            you’re making a significant difference to the development and
            sustainability of PostGraphile, Gra<em>fast</em>, and the wider
            suite of Graphile developer tooling
          </strong>
        </li>
      </ul>} mdxType="Tier" />
        </Tiers>
      </MarketingSection>
      <MarketingDivide from="medium" to="dark" via="light" down mdxType="MarketingDivide" />
      <MarketingSection bg="dark" left maxWidth mdxType="MarketingSection">
        <h3>{`How is sponsorship money spent?`}</h3>
        <p>{`Sponsorship money is used to fund software development, testing, documentation
and releases of PostGraphile and the Graphile suite. A small amount is also used
to send rewards such as stickers and learning materials to our backers.`}</p>
      </MarketingSection>
      <MarketingDivide from="dark" to="medium" down mdxType="MarketingDivide" />
      <MarketingSection bg="medium" left maxWidth mdxType="MarketingSection">
        <h3>{`Is sponsorship required to use Graphile’s OSS?`}</h3>
        <p>{`Users are not legally required to give back to the Graphile project, but it is
in their interest to do so.`}</p>
        <p>{`By significantly reducing the amount of work needed to achieve business goals
and reducing running costs, Graphile's software results in huge time and money
savings for users. We encourage organizations to contribute a portion of these
savings back, enabling the projects to advance more rapidly, and result in even
greater savings for your organization.`}</p>
      </MarketingSection>
      <MarketingDivide from="medium" to="dark" via="light" mdxType="MarketingDivide" />
      <MarketingSection bg="dark" left maxWidth mdxType="MarketingSection">
        <h3>{`How can I sponsor?`}</h3>
        <p>{`Our preferred sponsorship provider is currently GitHub since they are waiving
all fees:`}</p>
        <div className="tc">
  <a className="button--solid" href="https://github.com/users/benjie/sponsorship">
    Fee-free sponsorship via GitHub Sponsors{" "}
    <span className="fas fa-fw fa-external-link-square-alt" />
  </a>
        </div>
        <p>{`If you wish to sponsor through other means, please get in touch with
team@graphile, or DM Benjie or Jem `}<a parentName="p" {...{
            "href": "http://discord.gg/graphile"
          }}>{`on Discord`}</a>{`.`}</p>
        <h1>{`💙 Thank you, sponsors! ❤️`}</h1>
      </MarketingSection>
    </MarketingLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      